import React from 'react';
import classnames from 'classnames';
import { TableCell } from '@material-ui/core';
import moment from 'moment';
import ShiftInformation from './ShiftInformation';
import '../../shared/Table.css';

const Cell = ({ schedule, date }) => {
  const hasSchedules = schedule && schedule.length > 0;
  const wrapperCellClassnames = classnames({
    'flex-rows': true,
    'schedulingRowCell': true,
    'scheduleRowTimeCell': true,
    'shift-cell-today': moment(date).isSame(moment(), 'day')
  });

  return (
    <TableCell className={wrapperCellClassnames}>
      <div className='flex-1 flex-columns'>
        { hasSchedules
          ? schedule.map((shift, index) => {
            return (
              <ShiftInformation
                key={index}
                shift={shift}
                lastShiftInCell={index === schedule.length - 1}
              />
            );
          })
          : null
        }
      </div>
    </TableCell>
  );
};

export default Cell;
